export default "__VITE_ASSET__cq7BA5Os__"